import React from 'react';
import { connect } from 'react-redux';
import pt from 'prop-types';
import actions from 'partners/actions';

import StoreIcon from 'components/store/icon';
import SelectRecordsModal from './SelectRecords';

const fields = {
  name: {
    label: 'Store',
    columns: [
      {
        id: 'icon',
        label: 'Store',
        type: 'image',
        func(store) {
          return <StoreIcon store={store} size={48} />;
        },
      },
      {
        id: 'name',
        path: 'name',
      },
    ],
  },
  id: {
    label: 'ID',
  },
};

const mapDispatchToProps = (dispatch) => ({
  fetchCandidates: () => {
    return dispatch(actions.clients.fetchLinkCandidates());
  },
});

class LinkStores extends React.PureComponent {
  static propTypes = {
    title: pt.string,
    action: pt.string,
    width: pt.number,
    onSubmit: pt.func,
    onCancel: pt.func,

    fetchCandidates: pt.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      collection: {},
    };
  }

  async componentDidMount() {
    const { fetchCandidates } = this.props;
    const collection = await fetchCandidates();

    this.setState({
      loading: false,
      collection: collection || {},
    });
  }

  render() {
    const {
      title = 'Link stores',
      action = 'Connect stores',
      width = 760,
      onSubmit,
      onCancel,
    } = this.props;
    const { loading, collection } = this.state;

    return (
      <SelectRecordsModal
        title={title}
        recordsLabel="stores"
        action={action}
        width={width}
        alert="All users in this partner account get the same level of access to any store you connect."
        collection={collection}
        fields={fields}
        loading={loading}
        onSubmit={onSubmit}
        onCancel={onCancel}
      />
    );
  }
}

export default connect(null, mapDispatchToProps)(LinkStores);
